import React from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import ExternalLayout from './components/common/ExternalLayout';
import ExternalOpenLayout from './components/common/ExternalOpenLayout';
import InternalLayout from './components/common/InternalLayout';
import Logout from './components/user/LogOut';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLayout from './components/common/AuthLayout';
import JoinGroupPage from './components/groups/JoinGroupPage';
import GarminAccessTokenControl from './components/Integrations/Garmin/GarminAccessTokenControl';
import GA from './components/utils/GoogleAnalytics'

export default () => (

<BrowserRouter>
    <div className="App">
        {GA.init() && <GA.RouteTracker />}
        <Switch>
            <Route path='/dashboard' component={InternalLayout} />
            <Route path='/routes' component={InternalLayout} />
            <Route path='/user' component={InternalLayout} />
            <Route path='/groups/joingroup' component={JoinGroupPage} />
            <Route path='/groups' component={InternalLayout} />
            <Route path='/events' component={InternalLayout} />
            <Route path='/posts' component={InternalLayout} />
            <Route path='/_adm' component={InternalLayout} />
            <Route path='/resourceunavailable' component={InternalLayout} />
            <Route path='/lost' component={InternalLayout} />
            <Route path='/oops' component={InternalLayout} />
            <Route path='/ext/routes' component={ExternalOpenLayout} />
            <Route path='/about' component={ExternalOpenLayout} />
            <Route path='/login' component={AuthLayout} />
            <Route path='/logout' component={Logout} />
            <Route path='/signup' component={AuthLayout} />
            <Route path='/forgotten' component={AuthLayout} />
            <Route path='/resetpassword' component={AuthLayout} />
            <Route path='/activate' component={AuthLayout} />
            <Route path='/garmin' component={GarminAccessTokenControl} />
            <Route path='/' component={ExternalLayout} />
        </Switch>
        <ToastContainer autoClose={3000} hideProgressBar />
    </div>
</BrowserRouter >
);



// WEBPACK FOOTER //
// ./src/App.js